/*
  中文
*/
export default {
  commodity: {}
}
